"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyDrawCurvePropType = exports.SankeyDataPropTypes = exports.TagsCatalogPropTypes = exports.TagsGroupPropTypes = exports.SankeyLinkPropTypes = exports.SankeyLinkValueDictTypes = exports.SankeyLinkValueTypes = exports.SankeyNodePropTypes = void 0;
const prop_types_1 = __importDefault(require("prop-types"));
exports.SankeyNodePropTypes = {
    // identification
    idNode: prop_types_1.default.string.isRequired,
    name: prop_types_1.default.string.isRequired,
    //- level attributes
    dimensions: prop_types_1.default.objectOf(prop_types_1.default.shape({
        parent_name: prop_types_1.default.string,
        level: prop_types_1.default.number,
    }).isRequired).isRequired,
    // DISPLAY ATTRIBUTES
    // display controls the agregation desagregation process. 
    display: prop_types_1.default.bool.isRequired,
    // hide_lone_node:PropTypes.bool.isRequired,
    // node_visible controls the other process in particular tags manipulations
    node_visible: prop_types_1.default.bool.isRequired,
    // shape_visible and label_visible control the visibility of the element of the node
    shape_visible: prop_types_1.default.bool.isRequired,
    label_visible: prop_types_1.default.bool.isRequired,
    node_width: prop_types_1.default.number.isRequired,
    node_height: prop_types_1.default.number.isRequired,
    // iconName: PropTypes.string.isRequired,
    // iconColor: PropTypes.string.isRequired,
    // iconRatio: PropTypes.number.isRequired,
    // iconVisible: PropTypes.bool.isRequired,
    color: prop_types_1.default.string.isRequired,
    colorParameter: prop_types_1.default.string.isRequired,
    colorTag: prop_types_1.default.string.isRequired,
    colorSustainable: prop_types_1.default.bool.isRequired,
    // geometry
    position: prop_types_1.default.oneOf(['absolute', 'relative']).isRequired,
    x: prop_types_1.default.number.isRequired,
    y: prop_types_1.default.number.isRequired,
    x_label: prop_types_1.default.number,
    y_label: prop_types_1.default.number,
    show_value: prop_types_1.default.bool.isRequired,
    not_to_scale: prop_types_1.default.bool.isRequired,
    not_to_scale_direction: prop_types_1.default.string.isRequired,
    tooltip_text: prop_types_1.default.string,
    // topology
    inputLinksId: prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired,
    outputLinksId: prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired,
    // semantic
    shape: prop_types_1.default.oneOf(['ellipse', 'rect']).isRequired,
    tags: prop_types_1.default.objectOf(prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired).isRequired,
    style: prop_types_1.default.string.isRequired,
    //display
    display_style: prop_types_1.default.shape({
        font_family: prop_types_1.default.string.isRequired,
        font_size: prop_types_1.default.number.isRequired,
        uppercase: prop_types_1.default.bool.isRequired,
        bold: prop_types_1.default.bool.isRequired,
        italic: prop_types_1.default.bool.isRequired,
        //unit: PropTypes.bool.isRequired,
        //filter: PropTypes.number.isRequired,
        //filter_label: PropTypes.number.isRequired,
        //global_curvature: PropTypes.number.isRequired,
        //null_flux: PropTypes.bool.isRequired,
        label_vert: prop_types_1.default.string.isRequired,
        label_horiz: prop_types_1.default.string.isRequired,
        label_vert_valeur: prop_types_1.default.string.isRequired,
        label_horiz_valeur: prop_types_1.default.string.isRequired,
        value_font_size: prop_types_1.default.number.isRequired,
        label_box_width: prop_types_1.default.number.isRequired,
        label_color: prop_types_1.default.bool.isRequired
    }).isRequired,
};
exports.SankeyLinkValueTypes = {
    value: prop_types_1.default.any,
    // is_percent:PropTypes.bool.isRequired,
    // percent:PropTypes.number.isRequired,
    display_value: prop_types_1.default.string.isRequired,
    tags: prop_types_1.default.objectOf(prop_types_1.default.string.isRequired).isRequired,
    // for previous_value, data_value, data_source, data_period, mini, maxi ...
    extension: prop_types_1.default.objectOf(prop_types_1.default.string.isRequired)
};
exports.SankeyLinkValueDictTypes = prop_types_1.default.objectOf(prop_types_1.default.shape(exports.SankeyLinkValueTypes).isRequired).isRequired;
exports.SankeyLinkPropTypes = {
    // identification
    idLink: prop_types_1.default.string.isRequired,
    idSource: prop_types_1.default.string.isRequired,
    idTarget: prop_types_1.default.string.isRequired,
    // type of link
    recycling: prop_types_1.default.bool.isRequired,
    orientation: prop_types_1.default.string.isRequired,
    arrow: prop_types_1.default.bool.isRequired,
    // display_attribute
    label_position: prop_types_1.default.string.isRequired,
    orthogonal_label_position: prop_types_1.default.string.isRequired,
    label_on_path: prop_types_1.default.bool.isRequired,
    label_visible: prop_types_1.default.bool.isRequired,
    label_font_size: prop_types_1.default.number.isRequired,
    text_color: prop_types_1.default.string.isRequired,
    color: prop_types_1.default.string.isRequired,
    colorParameter: prop_types_1.default.string.isRequired,
    colorTag: prop_types_1.default.string.isRequired,
    // Ajout
    dashed: prop_types_1.default.bool.isRequired,
    to_precision: prop_types_1.default.bool.isRequired,
    value: prop_types_1.default.oneOfType([exports.SankeyLinkValueDictTypes, prop_types_1.default.shape(exports.SankeyLinkValueTypes).isRequired]).isRequired,
    tooltip_text: prop_types_1.default.string,
    // geometry
    x_label: prop_types_1.default.number,
    y_label: prop_types_1.default.number,
    left_horiz_shift: prop_types_1.default.number.isRequired,
    right_horiz_shift: prop_types_1.default.number.isRequired,
    vert_shift: prop_types_1.default.number,
    curvature: prop_types_1.default.number.isRequired,
    curved: prop_types_1.default.bool.isRequired,
    //style
    style: prop_types_1.default.string.isRequired
};
exports.TagsGroupPropTypes = {
    group_name: prop_types_1.default.string.isRequired,
    show_legend: prop_types_1.default.bool.isRequired,
    color_map: prop_types_1.default.string.isRequired,
    tags: prop_types_1.default.objectOf(prop_types_1.default.shape({
        name: prop_types_1.default.string.isRequired,
        shape: prop_types_1.default.string,
        color: prop_types_1.default.string,
        selected: prop_types_1.default.bool.isRequired,
    }).isRequired).isRequired,
    banner: prop_types_1.default.string.isRequired,
    activated: prop_types_1.default.bool.isRequired,
    siblings: prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired
};
exports.TagsCatalogPropTypes = prop_types_1.default.objectOf(prop_types_1.default.shape(exports.TagsGroupPropTypes).isRequired).isRequired;
//-------------------------
exports.SankeyDataPropTypes = {
    version: prop_types_1.default.string.isRequired,
    file_name: prop_types_1.default.string,
    couleur_fond_sankey: prop_types_1.default.string.isRequired,
    displayed_node_selector: prop_types_1.default.bool.isRequired,
    displayed_link_selector: prop_types_1.default.bool.isRequired,
    user_scale: prop_types_1.default.number.isRequired,
    maximum_flux: prop_types_1.default.number,
    accordeonToShow: prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired,
    style_node: prop_types_1.default.objectOf(prop_types_1.default.shape(exports.SankeyNodePropTypes).isRequired).isRequired,
    style_link: prop_types_1.default.objectOf(prop_types_1.default.shape(exports.SankeyLinkPropTypes).isRequired).isRequired,
    // icon_catalog: PropTypes.objectOf(PropTypes.string).isRequired,
    show_structure: prop_types_1.default.oneOf(['structure', 'data', 'reconciled', 'free_value', 'free_interval']).isRequired,
    //show_data: PropTypes.bool.isRequired,
    fit_screen: prop_types_1.default.bool.isRequired,
    height: prop_types_1.default.number.isRequired,
    width: prop_types_1.default.number.isRequired,
    h_space: prop_types_1.default.number.isRequired,
    v_space: prop_types_1.default.number.isRequired,
    left_shift: prop_types_1.default.number.isRequired,
    right_shift: prop_types_1.default.number.isRequired,
    max_shift: prop_types_1.default.number.isRequired,
    legend_position: prop_types_1.default.arrayOf(prop_types_1.default.number.isRequired).isRequired,
    nodes: prop_types_1.default.objectOf(prop_types_1.default.shape(exports.SankeyNodePropTypes).isRequired).isRequired,
    links: prop_types_1.default.objectOf(prop_types_1.default.shape(exports.SankeyLinkPropTypes).isRequired).isRequired,
    display_style: prop_types_1.default.shape({
        filter: prop_types_1.default.number.isRequired,
        filter_label: prop_types_1.default.number.isRequired,
        null_flux: prop_types_1.default.bool.isRequired,
        font_family: prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired,
        node_font_family_selected: prop_types_1.default.string.isRequired,
        link_font_family_selected: prop_types_1.default.string.isRequired
    }).isRequired,
    grid_square_size: prop_types_1.default.number.isRequired,
    grid_visible: prop_types_1.default.bool.isRequired,
    static_sankey: prop_types_1.default.bool.isRequired,
    nodeTags: exports.TagsCatalogPropTypes,
    dataTags: exports.TagsCatalogPropTypes,
    fluxTags: exports.TagsCatalogPropTypes,
    colorMap: prop_types_1.default.string.isRequired,
    legend_width: prop_types_1.default.number.isRequired,
    // view: PropTypes.arrayOf(
    //   PropTypes.shape({
    //     id: PropTypes.string.isRequired,
    //     view_data: PropTypes.object.isRequired,
    //     nom:PropTypes.string.isRequired,
    //     details:PropTypes.string.isRequired
    //   }).isRequired
    // ).isRequired
};
exports.SankeyDrawCurvePropType = {
    curve: prop_types_1.default.func.isRequired
};
